<template>
    <div>
        <a class="dropdown-item" href="javascript:void(0)" @click="$refs.reportImportModal.show()">
            <b-icon-cloud-upload></b-icon-cloud-upload> Import report
        </a>

        <b-modal
            id="report-import-modal"
            ref="reportImportModal"
            title="Import report from DotagMobile"
            ok-title="Import"
            :ok-disabled="importButtonDisabled"
            size="md"
            @ok="importReport"
            @cancel="onCancelReportImport">
            <p>You can import saved reports from your mobile device.</p>

            <b-form-file
                id="projects-index-file"
                v-model="archiveFile"
                browse-text=""
                accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
                placeholder="Click to choose a file or drop it here..."
                drop-placeholder="Drop files here..."/>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import EventBus from "@mobile/utils/event-bus";

export default {
    components: {},
    data() {
        return {
            archiveFile: null,
            importButtonDisabled: true
        }
    },
    watch: {
        archiveFile(file){
            this.importButtonDisabled = !file;
        }
    },
    computed: {},
    mounted() {
    },
    methods: {
        onCancelReportImport() {
            this.archiveFile = null;
            this.$refs.reportImportModal.hide();
        },

        importReport() {
            this.importButtonDisabled = true;

            EventBus.$emit('SHOW_LOADER', {
                title: "Your report is currently being imported",
                message: "As soon as it's finished you will be able to preview it. Please wait and do not leave this screen."
            });

            let token = this.$store.state.token;

            let formData = new FormData();

            formData.append('archiveFile', this.archiveFile);

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };

            return axios({
                url: this.$store.getters.apiProjectBase + '/reports/import',
                method: 'POST',
                headers: {"Authorization": "Bearer " + token},
                data: formData,
            }, config)
                .then(response => {
                    EventBus.$emit('HIDE_LOADER');
                    this.onCancelReportImport();
                    this.$emit('reportImported', response.data.data);
                    this.importButtonDisabled = false;
                })
                .catch(error => {
                    EventBus.$emit('HIDE_LOADER');
                    alert('Something went wrong during the report import. Please try again or contact Dotag Support if the problem persists.');
                    this.importButtonDisabled = false;
                });
        }
    }
}
</script>

<style scoped>
.custom-file {
    border: 1px solid #ccc;
    border-radius: 3px;
    height: auto;
}
</style>
